"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _formatMessage = _interopRequireDefault(require("../format-message"));

require("../rce/languages/bg_BG");

/*
 * Copyright (C) 2018 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
var locale = {
  announcements_a4b8ed4a: {
    message: "\u041E\u0431\u044F\u0432\u043B\u0435\u043D\u0438\u044F"
  },
  assignments_1e02582c: {
    message: "\u0417\u0430\u0434\u0430\u043D\u0438\u044F"
  },
  c_2001_acme_inc_283f7f80: {
    message: "(c) 2001 Acme Inc."
  },
  discussions_a5f96392: {
    message: "\u0414\u0438\u0441\u043A\u0443\u0441\u0438\u0438"
  },
  files_c300e900: {
    message: "\u0424\u0430\u0439\u043B\u043E\u0432\u0435"
  },
  folder_705fd2d7: {
    message: "\u041F\u0430\u043F\u043A\u0430"
  },
  grades_a61eba0a: {
    message: "\u041E\u0446\u0435\u043D\u043A\u0438"
  },
  loading_25990131: {
    message: "\u0417\u0430\u0440\u0435\u0436\u0434\u0430\u043D\u0435..."
  },
  modules_c4325335: {
    message: "\u041C\u043E\u0434\u0443\u043B\u0438"
  },
  pages_e5414c2c: {
    message: "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0438"
  },
  people_b4ebb13c: {
    message: "\u0425\u043E\u0440\u0430"
  },
  quizzes_7e598f57: {
    message: "T\u0435\u0441\u0442\u043E\u0432\u0435"
  },
  search_280d00bd: {
    message: "\u0422\u044A\u0440\u0441\u0438"
  },
  upload_8b403d05: {
    message: "\u041A\u0430\u0447\u0438"
  }
};

_formatMessage.default.addLocale({
  bg: locale
});